import { Colors } from '../../../themes/colors';

export const CandidateStatus = Object.freeze({
  APPLIED: 'applied',
  SCHEDULED: 'scheduled',
  INTERVIEWED: 'interviewed',
  HIRED: 'hired',
  REJECTED: 'rejected',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
});

export const translationsHumanReadable = Object.freeze({
  [CandidateStatus.APPLIED]: 'Applied',
  [CandidateStatus.SCHEDULED]: 'Scheduled',
  [CandidateStatus.INTERVIEWED]: 'Interviewed',
  [CandidateStatus.HIRED]: 'Hired',
  [CandidateStatus.REJECTED]: 'Rejected',
  [CandidateStatus.EXPIRED]: 'Expired',
  [CandidateStatus.CANCELLED]: 'Cancelled',
});

const colors = Object.freeze({
  [CandidateStatus.APPLIED]: Colors.primary_500,
  [CandidateStatus.SCHEDULED]: Colors.secondary_500,
  [CandidateStatus.INTERVIEWED]: Colors.neutral_600,
  [CandidateStatus.HIRED]: Colors.success_500,
  [CandidateStatus.REJECTED]: Colors.error_500,
  [CandidateStatus.EXPIRED]: Colors.warning_500,
  [CandidateStatus.CANCELLED]: Colors.warning_500,
});

const shortlistIneligibleStatuses = [
  CandidateStatus.HIRED,
  CandidateStatus.REJECTED,
  CandidateStatus.EXPIRED,
  CandidateStatus.CANCELLED,
];

export const CandidateStatusMapper = {
  getColor: (it) => colors[it],
  toHumanReadable: (it) => translationsHumanReadable[it],
  canShortlist: (it) => !shortlistIneligibleStatuses.includes(it),
};
